export default {
  state: {
    loading: false,
  },
  mutations: {
    setCasesLoading(state, status) {
      state.loading = status
    },
  },
  actions: {
    getCasesList({ commit }) {
      commit('setCasesLoading', true)
      return axios
        .get('/?m=News&a=getPostsByCategory&category=7')
        .then(res => res.data.posts)
        .catch(console.error)
        .finally(( ) => commit("setCasesLoading", false))
    },
  },
  getters: {
    getCasesLoading: state => state.loading,
  }
}
